import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Modal = ({ item, toggleTab, toggleState, handleClickOutside }) => {
  return (
    <div
      id="modal"
      className={
        toggleState === 1 ? "works__modal active-modal" : "works__modal"
      }
      onClick={handleClickOutside}
    >
      <div className="works__modal-content">
        <i
          onClick={() => toggleTab(0)}
          className="uil uil-times works__modal-close"
        ></i>

        <Slider
          className="arrow"
          arrows={true}
          dots={false}
          infinite={true}
          speed={500}
          slidesToShow={1}
          slidesToScroll={1}
          initialSlide={0}
          autoplay={true}
          autoplaySpeed={2500}
        >
          {item.images && item.images.length > 0 ? (
            item.images.map((image, index) => (
              <img key={index} src={image} alt="" className="work__image" />
            ))
          ) : (
            <p>No Images Found</p>
          )}
        </Slider>
        <br />
        <h3 className="modal-work__title">{item.title}</h3>

        <span className="work__modal-title" style={{ paddingBottom: "5px" }}>
          {item.description}{" "}
        </span>

        <h3 className="modal-work__title">
          <span className="work__modal-title">Role: </span> {item.role}
        </h3>

        <h3 className="modal-work__title">
          <span className="work__modal-title">Tools used: </span> {item.tools}
        </h3>

        <h3 className="modal-work__title">
          <span className="work__modal-title">Github repository link: </span>
          <a href={item.github} target="_blank">
              {item.github}
            </a>
        </h3>

        {item.url && (
          <h3 className="modal-work__title">
            <span className="work__modal-title">Project Link: </span>{" "}
            <a href={item.url} target="_blank">
              {item.url}
            </a>
          </h3>
        )}
      </div>
    </div>
  );
};

export default Modal;
